import { InputAdornment, TextField as MaterialTextField } from '@mui/material';
import type { TextFieldProps as MuiTextFieldProps } from '@mui/material/TextField';
import type { InputProps } from '@mui/material/Input';

export type DataAttributes = Record<
  `data-${string}`,
  string | number | boolean
>;

export type WithDataAttributes<T> = T & Partial<DataAttributes>;

export interface CustomTextFieldSlotProps {
  input?: Partial<InputProps>;
  htmlInput?: WithDataAttributes<
    React.InputHTMLAttributes<HTMLInputElement | HTMLTextAreaElement>
  >;
}

export type CustomTextFieldProps = Omit<MuiTextFieldProps, 'slotProps'> & {
  slotProps?: CustomTextFieldSlotProps;
};

export const TextField = ({
  slotProps,
  ...restProps
}: CustomTextFieldProps) => {
  const inputProps = slotProps?.input ?? {};

  let newSlotProps = slotProps ? { ...slotProps } : undefined;

  if (inputProps.startAdornment || inputProps.endAdornment) {
    newSlotProps = {
      ...slotProps,
      input: {
        ...inputProps,
        ...(inputProps.startAdornment
          ? {
              startAdornment: (
                <InputAdornment position='start'>
                  {inputProps.startAdornment}
                </InputAdornment>
              ),
            }
          : {}),
        ...(inputProps.endAdornment
          ? {
              endAdornment: (
                <InputAdornment position='end'>
                  {inputProps.endAdornment}
                </InputAdornment>
              ),
            }
          : {}),
      },
    };
  }

  return <MaterialTextField {...restProps} slotProps={newSlotProps} />;
};
